import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "react-grid-system";
import showAlert from "../../../server/ShowAlert";
import { createPromotion, updatePromotion } from "../../../server/PriceList";
import FamilyChangeDialog from "./FamilyChangeDialog";
import { setProducts } from "../../../server/Product";
import { getBySlug } from "../../../server/Category";

const Promotion = ({ promo = 0, product, close = null, onCreated = null }) => {
  const [promoType, setPromoType] = useState("FLAT");
  const [discauntValue, setDiscauntValue] = useState("");
  const [promoStatus, setPromoStatus] = useState("ACTIVE");
  const [promoStartDate, setPromoStartDate] = useState("");
  const [promoEndDate, setPromoEndDate] = useState("");
  const [description, setDescription] = useState("");
  const [isSavingPromo, setIsSavingPromo] = useState(false);
  const [minQuantity, setMinQuantity] = useState("");
  const [maxPerPurchase, setMaxPerPurchase] = useState(null);
  const [maxPerPeriod, setMaxPerPeriod] = useState(null);
  const [totalAllocatedQty, setTotalAllocatedQty] = useState(null);
  const [changes, setChanges] = useState({ targetProducts: [product.gtin] });
  const [showFamilyDialog, setShowFamilyDialog] = useState(false);

  const { stationId, products, categories } = useSelector((state) => ({
    stationId: state.user.stationId,
    products: state.displayProduct.itemsShow,
    categories: state.selectedProduct.productCategories,
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    if (promo !== 0) {
      setPromoType(promo.promoType);
      setPromoStatus(promo.status);
      setDiscauntValue(promo.discountValue);
      setDiscauntValue(promo.discountValue);
      setMinQuantity(promo.minQuantity);
      setPromoStartDate(promo.startDate.split("T")[0]);
      setPromoEndDate(promo.endDate.split("T")[0]);
      setDescription(promo.description);
      setMinQuantity(promo.minQuantity);
      setMaxPerPeriod(promo.maxPerPeriod);
      setMaxPerPurchase(
        promo.maxPerPurchase === 0 ? null : promo.maxPerPurchase,
      );
      setTotalAllocatedQty(promo.totalAllocatedQty);
      setChanges({ targetProducts: promo.targetProducts });
    }
  }, [promo]);

  const handleChange = (field, value) => {
    setChanges((prev) => ({ ...prev, [field]: value }));
  };

  const handleSavePromo = async () => {
    if (Object.keys(changes).length === 0) {
      showAlert({ msgTitle: "אין שינויים", msgType: "error" });
      return;
    }

    if (categories[0].isFamily) {
      getBySlug(stationId, categories[0].slug).then((res) => {
        console.log(res);
        dispatch(setProducts(res.products));
      });
      setShowFamilyDialog(true);
      return;
    }

    if (promo === 0) createNewPromotion(changes);
    else upadateExistingPromotion(changes);
  };

  const createNewPromotion = async (updatedChanges) => {
    try {
      if (!promoStartDate || !promoEndDate) {
        showAlert({ msgTitle: "אנא מלא תאריכי התחלה וסיום", msgType: "error" });
        return;
      }
      if (promoType === "FLAT" && !discauntValue) {
        showAlert({ msgTitle: "אנא הזן מחיר מבצע", msgType: "error" });
        return;
      }
      if (promoType === "PERCENT" && !discauntValue) {
        showAlert({ msgTitle: "אנא הזן אחוז הנחה", msgType: "error" });
        return;
      }
      if (promoType === "QUANTITY_PRICE" && (!discauntValue || !minQuantity)) {
        showAlert({ msgTitle: "אנא הזן כמות ומחיר למבצע", msgType: "error" });
        return;
      }

      setIsSavingPromo(true);
      const newPromoData = {
        branch: stationId.toString(),
        status: promoStatus,
        promoType: promoType,
        retailer: "Hamazon",
        minQuantity: minQuantity === "" ? null : minQuantity,
        maxPerPurchase: maxPerPurchase ? maxPerPeriod : 0,
        maxPerPeriod: maxPerPeriod,
        totalAllocatedQty: totalAllocatedQty,
        ...updatedChanges,
      };
      await createPromotion(newPromoData);

      showAlert({
        msgTitle: "המבצע נוצר בהצלחה",
        msgType: "success",
      });

      setChanges({});
      onCreated?.();
      close();
    } catch {
      showAlert({ msgTitle: "שגיאה ביצירת מבצע", msgType: "error" });
    } finally {
      setIsSavingPromo(false);
    }
    return;
  };

  const upadateExistingPromotion = async (updatedChanges) => {
    try {
      setIsSavingPromo(true);
      await updatePromotion(promo.promoId, updatedChanges);

      showAlert({
        msgTitle: "השינויים עודכנו בהצלחה",
        msgType: "success",
      });

      setChanges({});
    } catch {
      showAlert({ msgTitle: "שגיאה בעדכון", msgType: "error" });
    } finally {
      setIsSavingPromo(false);
    }
  };

  const formatDateTimeForJerusalem = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const jerusalemTime = new Intl.DateTimeFormat("en-US", {
      timeZone: "Asia/Jerusalem",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).formatToParts(date);
    const parts = {};
    jerusalemTime.forEach((part) => {
      parts[part.type] = part.value;
    });
    const formatted = `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}.000+02:00`;
    return formatted;
  };

  const handleSaveFamilyPromo = (productsToChange) => {
    const updatedChanges = { ...changes };
    updatedChanges["targetProducts"] = productsToChange.map(
      (prod) => prod.gtin,
    );
    if (promo === 0) {
      createNewPromotion(updatedChanges);
    } else {
      upadateExistingPromotion(updatedChanges);
    }
    setShowFamilyDialog(false);
  };
  console.log(maxPerPeriod);

  return (
    <>
      <div className={promo !== 0 ? `section-card` : `new-promo-section`}>
        <h3 className="section-title">
          {promo === 0 ? "יצירת מבצע" : `מבצע ${promo.promoId}`}
        </h3>
        <Row className="promo-type-row">
          <Col sm={2}>
            <div className="field-group">
              <label className="field-label">סטטוס</label>
              <select
                className="promo-type-select"
                value={promoStatus}
                onChange={(e) => {
                  setPromoStatus(e.target.value);
                  handleChange("status", e.target.value);
                }}
              >
                <option value="ACTIVE">פעיל</option>
                <option value="SCHEDULED">מתוזמן</option>
                <option value="EXPIRED">פג תוקף</option>
                <option value="DISABLED">מוקפא</option>
                <option value="DRAFT">טיוטה</option>
              </select>
            </div>
          </Col>
          {promo === 0 && (
            <Col sm={2.5}>
              <div className="field-group">
                <label className="field-label">סוג</label>
                <select
                  className="promo-type-select"
                  value={promoType}
                  onChange={(e) => {
                    setPromoType(e.target.value);
                    handleChange("promoType", e.target.value);
                  }}
                >
                  <option value="FLAT">מחיר</option>
                  <option value="PERCENT">אחוז הנחה</option>
                  <option value="QUANTITY_PRICE">מחיר לכמות</option>
                </select>
              </div>
            </Col>
          )}
          {promoType === "FLAT" && (
            <Col sm={2}>
              <div className="field-group">
                <label className="field-label">מחיר</label>
                <input
                  type="number"
                  step="0.1"
                  className="number-input highlighted"
                  placeholder="0.0"
                  value={discauntValue}
                  onChange={(e) => {
                    setDiscauntValue(e.target.value);
                    handleChange("discountValue", parseFloat(e.target.value));
                  }}
                />
              </div>
            </Col>
          )}

          {promoType === "PERCENT" && (
            <Col sm={2}>
              <div className="field-group">
                <label className="field-label">אחוז הנחה (%)</label>
                <input
                  type="number"
                  min="0"
                  max="100"
                  step="1"
                  className="number-input highlighted"
                  placeholder="0-100"
                  value={discauntValue || ""}
                  onChange={(e) => {
                    setDiscauntValue(e.target.value);
                    handleChange("discountValue", parseFloat(e.target.value));
                  }}
                />
              </div>
            </Col>
          )}

          {promoType === "QUANTITY_PRICE" && (
            <>
              <Col sm={2}>
                <div className="field-group">
                  <label className="field-label">כמות</label>
                  <input
                    type="number"
                    min="1"
                    step="1"
                    className="number-input highlighted"
                    placeholder="יח'"
                    value={minQuantity || ""}
                    onChange={(e) => {
                      setMinQuantity(e.target.value);
                      handleChange("minQuantity", parseInt(e.target.value));
                    }}
                  />
                </div>
              </Col>
              <Col sm={2}>
                <div className="field-group">
                  <label className="field-label">מחיר</label>
                  <input
                    type="number"
                    step="0.01"
                    className="number-input highlighted"
                    placeholder="0.00"
                    value={discauntValue || ""}
                    onChange={(e) => {
                      setDiscauntValue(e.target.value);
                      handleChange("discountValue", parseFloat(e.target.value));
                    }}
                  />
                </div>
              </Col>
            </>
          )}
          {promoType !== "QUANTITY_PRICE" && (
            <Col sm={promo === 0 ? 5.5 : 7}>
              <div className="field-group">
                <label className="field-label">תיאור מבצע (אופציונלי)</label>
                <textarea
                  className="promo-description"
                  placeholder="תיאור המבצע..."
                  value={description || ""}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    handleChange("description", e.target.value);
                  }}
                />
              </div>
            </Col>
          )}
        </Row>

        <Row>
          <Col sm={3}>
            <div className="field-group small">
              <label className="field-label">הקצאה</label>
              <input
                type="number"
                className="number-input"
                placeholder="0"
                value={totalAllocatedQty}
                onChange={(e) => {
                  setTotalAllocatedQty(e.target.value);
                  handleChange("totalAllocatedQty", parseInt(e.target.value));
                }}
              />
            </div>
          </Col>
          {promoType !== "QUANTITY_PRICE" && (
            <Col sm={3}>
              <div className="field-group small">
                <label className="field-label">מינימום</label>
                <input
                  type="number"
                  className="number-input"
                  placeholder="0"
                  value={minQuantity}
                  onChange={(e) => {
                    setMinQuantity(e.target.value);
                    handleChange("minQuantity", parseInt(e.target.value));
                  }}
                />
              </div>
            </Col>
          )}
          <Col sm={3}>
            <div className="field-group small">
              <label className="field-label">הגבלת יח' קניה ללק׳</label>
              <input
                type="number"
                className="number-input"
                placeholder="0"
                value={maxPerPurchase}
                onChange={(e) => {
                  setMaxPerPurchase(e.target.value);
                  handleChange("maxPerPurchase", parseInt(e.target.value));
                }}
              />
            </div>
          </Col>
          <Col sm={3}>
            <div className="field-group small">
              <label className="field-label">הגבלת לק׳ לתקופה</label>
              <input
                type="number"
                className="number-input"
                placeholder="0"
                value={maxPerPeriod}
                onChange={(e) => {
                  setMaxPerPeriod(e.target.value);
                  handleChange("maxPerPeriod", parseInt(e.target.value));
                }}
              />
            </div>
          </Col>
        </Row>
        <Row className="promo-save-row">
          <Col sm={4}>
            <div className="field-group">
              <label className="field-label">תאריך התחלה</label>
              <input
                type="date"
                className="date-input"
                value={promoStartDate.split("T")[0] || ""}
                onChange={(e) => {
                  setPromoStartDate(e.target.value);
                  handleChange(
                    "startDate",
                    formatDateTimeForJerusalem(e.target.value),
                  );
                }}
              />
            </div>
          </Col>
          <Col sm={4}>
            <div className="field-group">
              <label className="field-label">תאריך סיום</label>
              <input
                type="date"
                className="date-input"
                value={promoEndDate.split("T")[0] || ""}
                onChange={(e) => {
                  setPromoEndDate(e.target.value);
                  handleChange(
                    "endDate",
                    formatDateTimeForJerusalem(e.target.value),
                  );
                }}
              />
            </div>
          </Col>
          <Col sm={4}>
            <div className="field-group">
              <label className="field-label">שמירה</label>
              <button
                className="save-promo-btn"
                onClick={handleSavePromo}
                disabled={isSavingPromo}
              >
                {isSavingPromo ? "שומר..." : "שמור מבצע"}
              </button>
            </div>
          </Col>
        </Row>
      </div>
      {showFamilyDialog && (
        <FamilyChangeDialog
          product={product}
          onConfirm={handleSaveFamilyPromo}
          close={() => setShowFamilyDialog(false)}
          markedProducts={products.filter((p) =>
            changes.targetProducts.includes(p.gtin),
          )}
          massage={"סמן את המוצרים שהינך רוצה שיהיו כלולים במבצע:"}
          slug={categories[0].slug}
        />
      )}
    </>
  );
};

export default Promotion;
